// src/api/auth.api.js
// ─────────────────────────────────────────────────────────────────────────────
//  All auth-related API calls in one place.
// ─────────────────────────────────────────────────────────────────────────────

import api from './axios';

export const loginApi   = (email, password) =>
  api.post('/auth/login',  { email, password });

export const logoutApi  = () =>
  api.post('/auth/logout');

export const getMeApi   = () =>
  api.get('/auth/me');
